import { gql } from 'apollo-angular';

export const CreateActivityDocument =
  gql(/* GraphQL*/ `mutation createActivity($input: ActivityInputGraphql!, $tacticId: Int!) {
  createActivity(input: $input, tacticId: $tacticId) {
    id
  }
}
`);
